import { VStack } from '@chakra-ui/react';
import React from 'react';

import { EditButton } from '../../../components/StyledButton';
import { pageKeywords, pagePaths } from '../../../constants/Page';
import { useGlobalStateMachine } from '../../../GlobalStore';
import { useEngeneNavigate } from '../../../hooks/navigate';
import { UserInfoAccordion } from './accordion/UserInfoAccordion';

/**
 * 閲覧モード
 * @returns
 */
const UserInfoView: React.FunctionComponent = () => {
  const { state } = useGlobalStateMachine();
  const navigate = useEngeneNavigate();

  return (
    <VStack paddingBottom={2} width="100%">
      <UserInfoAccordion
        defaultIndex={state.pageInfo.USER_INFO?.openedPanel || 0}
        mode="view"
      />
      <EditButton
        onClick={() =>
          navigate(`${pagePaths.USER_INFO}/${pageKeywords.mode.EDIT}`)
        }
      />
    </VStack>
  );
};

export default UserInfoView;
